<template>
    <div class="content__header content__header--one-item-per-line">
        <div class="content-header__back">
            <UIBackButton
                :text="'К списку авто'"
                :to="router.resolve({ name: 'CarsList' }).href"
            />
        </div>

        <div v-if="car" class="cars-list-detail-header__top">
            <div class="cars-list-detail-header__title">
                <div>{{ getCarFullName(car) }}</div>

                <div :class="['cars-list-detail-header__status', car.status]">
                    {{ getCarStatusLabel(car.status) }}
                </div>
            </div>

            <div
                v-if="canEditCar(car) || canDeleteCar(car) || canRecreateCar(car)"
                class="cars-list-detail-header__button-menu"
            >
                <UIDropDown as-modal-on-mobile>
                    <template #elements>
                        <router-link
                            v-if="canEditCar(car)"
                            :to="{ name: 'EditCar', params: { car_id: car.id } }"
                            class="ui-dropdown-menu__element"
                        >
                            <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
                            <span>Редактировать</span>
                        </router-link>

                        <li
                            v-if="canDeleteCar(car)"
                            class="ui-dropdown-menu__element danger"
                            @click="emit('delete')"
                        >
                            <img v-svg-inline src="@/assets/icons/ui/trash.svg" />
                            <span>Удалить</span>
                        </li>

                        <li
                            v-if="canRecreateCar(car)"
                            class="ui-dropdown-menu__element"
                            @click="emit('recreate')"
                        >
                            <img v-svg-inline src="@/assets/icons/ui/ph_copy-simple.svg" />
                            <span>Пересоздать</span>
                        </li>
                    </template>
                </UIDropDown>
            </div>
        </div>

        <div v-if="car" class="cars-list-detail-header__center">
            <div class="cars-list-detail-header__specs">{{ getCarSpecification(car) }}</div>
        </div>

        <div v-if="car && car.tags.length > 0" class="cars-list-detail-header__bottom">
            <CarTags :tags="car.tags" />
        </div>

        <div class="content-header__background cars-list-detail-header__background"></div>
    </div>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router';

    import {
        Car,
        getCarStatusLabel,
    } from '@/types/car.type.ts';

    import usePermission from '@/repositories/auth/usePermission.ts';

    import { getCarFullName, getCarSpecification } from '@/utils/car';

    import UIBackButton from '@/components/ui/UIBackButton/UIBackButton.vue';
    import UIDropDown from '@/components/ui/UIDropDown/UIDropDown.vue';

    import CarTags from '@/components/cars/CarTags/CarTags.vue';

    const { car } = defineProps<{
        car: Car | null,
    }>();

    const emit = defineEmits<{
        (e: 'edit'): void,
        (e: 'delete'): void,
        (e: 'recreate'): void,
    }>();

    const router = useRouter();
    const { canEditCar, canDeleteCar, canRecreateCar } = usePermission();
</script>

<style scoped lang="scss">
    @use './ViewCarHeader.scss' as *;
</style>
